/**
 * Get excise duty files list
 */

import { getToken } from "../utils";
import { BASE_URL } from "../endpoints";

const getFileList = async () => {
  const token = getToken();
  if (token) {
    try {
      const response = await fetch(`${BASE_URL}/api/excise_duty_files`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (response.status === 200) {
        const data = await response.json();
        return data.excise_duty_files;
      } else {
        return null;
      }
    } catch {
      return null; // network error
    }
  } else {
    return null; // No token or not admin
  }
};

export default getFileList;
